// Alpine.js v3 component registration
function fileUploaderComponent(initialFileName = null) {
    return {
        file: null,
        uploading: false,
        uploadedFileName: initialFileName,

        async handleFileChange(event) {
            const file = event.target.files[0];
            if (!file) return;

            const fileName = file.name;
            const fileSize = file.size;
            const fileType = file.type;

            this.file = file;
            this.uploading = true;

            try {
                // Use Livewire 3 syntax
                const urlResponse = await this.$wire.getTemporaryUploadUrl(fileType, fileSize, event.target.name.replace('file-', ''));

                // if size validation fails
                if(urlResponse === null) {
                    return;
                }
                await fetch(urlResponse.url, {
                    method: 'PUT',
                    body: file,
                });

                const temporaryUploadUuid = await this.$wire.createTemporaryUpload(
                    urlResponse,
                    fileName,
                    fileSize,
                    fileType
                );

                const fileInputId = event.target.id;
                const hiddenFieldId = fileInputId.replace('file-', '');

                const hiddenField = document.getElementById(hiddenFieldId);
                if (hiddenField) {
                    hiddenField.value = temporaryUploadUuid;
                    this.uploadedFileName = fileName;

                    hiddenField.dispatchEvent(new Event('input', {bubbles: true}));
                }
            } catch (error) {
                console.error("Upload error:", error);
            } finally {
                this.uploading = false;
                this.file = null;
            }
        },

        removeFile(inputId) {
            const fileInput = document.getElementById('file-' + inputId);
            const hiddenInput = document.getElementById(inputId);

            if (fileInput) {
                fileInput.value = '';
            }

            if (hiddenInput) {
                hiddenInput.value = '';
                this.uploadedFileName = null;

                hiddenInput.dispatchEvent(new Event('input', { bubbles: true }));
            }

            this.file = null;
            this.uploading = false;
        },
    };
}

// Register the component with Alpine.js
document.addEventListener('alpine:init', () => {
    window.Alpine.data('fileUploader', fileUploaderComponent);
});
